type SerachResultsUrlParams = {
	brandPath: string
	pathNameBase: string
	searchTerm?: string
}

export const searchUrl = ({
	brandPath,
	pathNameBase,
	searchTerm,
}: SerachResultsUrlParams) => {
	const pathName = `${pathNameBase}${brandPath}`

	if (!searchTerm) {
		return pathName
	}

	const searchParams = new URLSearchParams({
		q: encodeURIComponent(searchTerm),
	})

	return `${pathName}?${searchParams}`
}
